export default {"src":"/_next/static/media/menu-btn.e0c859a6.svg","height":16,"width":28,"blurWidth":0,"blurHeight":0};